import AltRouteIcon from '@mui/icons-material/AltRoute';
import { IconButton, Tooltip } from '@mui/material';
import React from 'react';
import { Loading } from '../../../../uikit';
import { appZIndex } from '../../../../styles/zIndex';

interface Props {
  active: boolean;
  onClick: () => void;
  tooltipTitle: string;
  loading?: boolean;
}

const activeButtonStyles = {
  bgcolor: 'primary.main',
  color: 'common.white',
  borderColor: 'primary.main',

  '&:hover': {
    bgcolor: 'primary.dark',
  },
};

const inactiveButtonStyles = {
  bgcolor: 'background.paper',
  color: 'text.primary',
  borderColor: 'divider',

  '&:hover': {
    bgcolor: 'grey.100',
  },
};

export default function EventOptimizeRouteControl({ active, onClick, tooltipTitle, loading = false }: Props) {
  return (
    <Tooltip title={tooltipTitle}>
      <IconButton
        disabled={loading}
        onClick={onClick}
        sx={{
          position: 'absolute', // Position control inside the map near navigation controls
          top: 120,
          right: 8,
          zIndex: appZIndex.raised,
          width: 36,
          height: 36,
          border: '1px solid',
          boxShadow: 2,
          transition: 'all .2s ease',

          ...(active ? activeButtonStyles : inactiveButtonStyles),

          '&.Mui-disabled': {
            opacity: 1,
            ...(active ? activeButtonStyles : inactiveButtonStyles),
          },
        }}
      >
        {loading ? <Loading size={18} color={active ? 'inherit' : 'primary'} /> : <AltRouteIcon fontSize="small" />}
      </IconButton>
    </Tooltip>
  );
}
